@if (isFirstParagraph && blockMedia.type === "block_full_hero_media") {
    <h-positioned-under-header>
        <ng-container *ngTemplateOutlet="mainSection"></ng-container>
    </h-positioned-under-header>
} @else {
    <ng-container *ngTemplateOutlet="mainSection"></ng-container>
}
<ng-template #mainSection>
    <section
        data-testid="block-media"
        [hAnimateOnScroll]="{
            animate: blockMedia.hasAnimation,
            threshold: 0.2,
        }"
        [class]="blockMediaClass"
        [class.white-background]="blockMedia.whiteBackground && blockMedia.type === 'block_standard_media'">
        @if (blockMedia.media) {
            <h-media-cta
                [media]="blockMedia.media"
                [mediaOptions]="mediaOptions"
                [preloadPoster]="shouldPreloadMedia"
                [isFillMode]="isImmersiveBlockMedia"></h-media-cta>
        }
    </section>
</ng-template>
